"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = GoogleMap;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _googleMap = _interopRequireDefault(require("./google-map.css"));
var _useGoogleMaps2 = _interopRequireDefault(require("../useGoogleMaps/useGoogleMaps"));
var _getMarker = _interopRequireDefault(require("../../../../components/map/getMarker"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var clusterMB = require('../../../../vendor/v3-utility-library/markerclusterer');
function GoogleMap(_ref) {
  var className = _ref.className,
    markers = _ref.markers,
    config = _ref.config,
    currentLocation = _ref.currentLocation,
    selectedDealer = _ref.selectedDealer,
    markerSelected = _ref.markerSelected;
  var mapRef = (0, _react.useRef)(null);
  var _useGoogleMaps = (0, _useGoogleMaps2["default"])(),
    mapsApi = _useGoogleMaps.mapsApi;
  var createMap = function createMap() {
    var mapEl = mapRef.current;
    var map = new mapsApi.maps.Map(mapEl, config);
    return map;
  };
  var setMouseEvent = function setMouseEvent(marker) {
    mapsApi.maps.event.addListener(marker, 'mouseover', function () {
      marker.setIcon((0, _getMarker["default"])({
        type: 'currentLocation',
        letter: '.',
        fillColor: '#ED0000'
      }));
    });
    mapsApi.maps.event.addListener(marker, 'mouseout', function () {
      marker.setIcon((0, _getMarker["default"])({
        type: 'currentLocation',
        letter: '.',
        fillColor: 'black'
      }));
    });
  };
  function setBoundary(markers, map) {
    var bounds = new mapsApi.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i].position);
    }
    map.fitBounds(bounds);
  }
  var addMarkers = function addMarkers(map) {
    var currentMarkers = markers.slice();
    if (currentLocation) {
      new mapsApi.maps.Marker({
        map: map,
        position: {
          lat: parseFloat(currentLocation.latitude, 10),
          lng: parseFloat(currentLocation.longitude, 10)
        },
        label: {
          text: ' ',
          className: 'currentLocation_google_map_marker'
        },
        icon: (0, _getMarker["default"])({
          type: 'currentLocation',
          letter: '.',
          fillColor: '#5A646E'
        })
      });
    }
    var markerArray = [];
    currentMarkers.forEach(function (marker) {
      var currentMarker = new mapsApi.maps.Marker(_objectSpread(_objectSpread({
        dealer: marker.dealer,
        map: map,
        label: marker.markerLabel || marker.label ? {
          text: marker.markerLabel || marker.label,
          className: marker.markerLabelClassName || 'google_map_marker'
        } : undefined
      }, marker), {}, {
        icon: (0, _getMarker["default"])({
          type: 'currentLocation',
          letter: '.',
          fillColor: selectedDealer ? '#ED0000' : 'black'
        }),
        position: {
          lat: parseFloat(marker.position.lat, 10),
          lng: parseFloat(marker.position.lng, 10)
        }
      }));
      mapsApi.maps.event.addListener(currentMarker, 'click', function () {
        var dealer = currentMarker.dealer; //dealerid
        markerSelected(dealer);
      });
      markerArray.push(currentMarker);
      !selectedDealer && setMouseEvent(currentMarker);
    });
    var markerCluster = new MarkerClusterer(map, markerArray, {
      clusterClass: "mini_dealer_markercluster"
    });
    !selectedDealer && setBoundary(currentMarkers, map);
  };
  (0, _react.useEffect)(function () {
    if (mapsApi) {
      var map = createMap();
      markers && addMarkers(map);
    }
  }, [markers, mapsApi]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _googleMap["default"].wrapper + " " + className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _googleMap["default"].map,
    ref: mapRef
  }));
}
GoogleMap.defaultProps = {
  className: '',
  markers: [],
  config: {}
};